// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_ma-1";
export var rowFirst = "_ma-3";
export var rowLast = "_ma-5";
export var rowMiddle = "_ma-4";
export var ticketListScroll = "_ma-2";
export var ticketStack = "_ma-0";